import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processChangeOrder = (store, item) => {
    if (item.user) {
        store.dispatch('processUser', item.user)
        delete item.user
    }

    if (item.project) {
        store.dispatch('processProject', item.project)
        delete item.project
    }

    if (item.company) {
        store.dispatch('processCompany', item.company)
        delete item.company
    }

    if (item.contact) {
        store.dispatch('processContact', item.contact)
        delete item.contact
    }

    if (item.project_services) {
        _.each(item.project_services, ps => store.dispatch('processEditingProjectService', ps))
        delete item.project_services
    }

    store.commit(mutations.ADD_OR_UPDATE_CHANGE_ORDER, item)
}

export const fetchChangeOrders = (store, params = {}) => {
    return axios.get(`/api/change-orders`, {params})
        .then(res => {
            _.each(res.data.data, item => processChangeOrder(store, item))
            return res
        })
}

export const fetchChangeOrder = (store, id) => {
    return axios.get(`/api/change-orders/${id}`)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}

export const createChangeOrder = (store, item) => {
    return axios.post('/api/change-orders', item)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}

export const updateChangeOrder = (store, item) => {
    return axios.patch(`/api/change-orders/${item.id}`, item)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}

export const createOrUpdateChangeOrder = (store, item) => {
    let project_services = store.getters.projectServicesBySource({
        source_id: item.id ? item.id : null,
        source_type: 'change-order'
    })

    project_services = _.map(project_services, (service, i) => {
        service.position = i
        return service
    })

    let payload = _.clone(item)
    payload.project_services = project_services

    return item.id ?
        updateChangeOrder(store, payload) :
        createChangeOrder(store, payload)
}

export const approveChangeOrder = (store, item) => {
    return axios.patch(`/api/change-orders/${item.id}/approve`, item)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}

export const declineChangeOrder = (store, item) => {
    return axios.patch(`/api/change-orders/${item.id}/decline`, item)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}

export const removeChangeOrder = (store, item) => {
    return axios.delete(`/api/change-orders/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_CHANGE_ORDER, item)
            return res
        })
}

export const sendChangeOrderEmail = (store, emailData) => {
    return axios.post(`/api/change-orders/${emailData.entityIdProperty}/email`, emailData)
}

export const updateChangeOrderRemindBy = (store, item) => {
    return axios.patch(`/api/change-orders/${item.id}/postpone`, item)
        .then(res => {
            processChangeOrder(store, res.data.data)
            return res
        })
}


